import React from 'react';
import PropTypes from 'prop-types';
import './HoverEffect.css';

const HoverEffect = ({ text }) => {
  return (
    <button className="button">
      <span className="static-text">&nbsp;{text}&nbsp;</span>
      <span className="hover-text" aria-hidden="true">&nbsp;{text}&nbsp;</span>
    </button>
  );
};

HoverEffect.propTypes = {
  text: PropTypes.string.isRequired,
};

export default HoverEffect;
